import React, { useCallback, useEffect } from "react";
import Script from "next/script";
import { useRouter } from "next/router";
import { GoogleAnalyticsContext } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// React Context Provider to pass GA functions around
// See: https://reactjs.org/docs/context.html
export var GoogleAnalyticsProvider = _ref => {
  var {
    measurementId,
    children
  } = _ref;
  var router = useRouter(); // Sends a page view to GA

  var pageview = useCallback(url => {
    if (window.gtag && measurementId) {
      window.gtag("config", measurementId, {
        page_path: url
      });
    }
  }, []); // Sends an event to GA

  var event = useCallback(_ref2 => {
    var {
      action,
      category,
      label,
      value
    } = _ref2;

    if (window.gtag && measurementId) {
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value
      });
    }
  }, []); // Handles page changes to send page views to GA
  // See thread: https://github.com/vercel/next.js/issues/160#issuecomment-788003613

  useEffect(() => {
    var handleRouteChange = url => {
      pageview(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return /*#__PURE__*/_jsxs(GoogleAnalyticsContext.Provider, {
    value: {
      pageview,
      event
    },
    children: [measurementId && /*#__PURE__*/_jsx(Script, {
      strategy: "afterInteractive",
      src: "https://www.googletagmanager.com/gtag/js?id=" + measurementId
    }), measurementId && /*#__PURE__*/_jsx(Script, {
      id: "gtag",
      strategy: "afterInteractive",
      children: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '" + measurementId + "', {\n              page_path: window.location.pathname,\n            });\n        "
    }), children]
  });
};
//# sourceMappingURL=provider.js.map